import * as React from "react";
const SVGComponent = ({ width = "15px", height = "15px", color = "var(--side-nav-btn-border-color)", ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={0.5}
      y={0.5}
      width={14}
      height={14}
      rx={7}
      fill="white"
      stroke={color}
    />
  </svg>
);
export default SVGComponent;